import requestsTab from './requestsTab';
import requestMarkdownTab from '../markdown/layout/requestMarkdownTab';
import requestsReviewTab from './requestsReviewTab';
import newRequestTab from './newRequestTab';
import requestTab from './requestTab';
import requestHistoryTab from './requestHistoryTab';
import requestCloneTab from './requestCloneTab';
import tasksTab from '../tasks/layout/tasksTab';

export default [
  newRequestTab,
  requestCloneTab,
  requestHistoryTab,
  requestMarkdownTab,
  requestsReviewTab,
  requestsTab,
  requestTab,
  tasksTab,
];
